"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = require("prop-types");

var _semanticUiReact = require("semantic-ui-react");

var _react = _interopRequireWildcard(require("react"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _ObjectUtils = require("@omniex/onx-common-js/lib/utils/ObjectUtils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 15px !important;\n  white-space: normal;\n\n  &.ui.message.icon > i {\n    font-size: 1.7em !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledMessage = (0, _reactEmotion.default)(_semanticUiReact.Message)(_templateObject());

var Message = function (_PureComponent) {
  (0, _inherits2.default)(Message, _PureComponent);

  function Message() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Message);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Message)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickHide", function () {
      if (_this.props.closeOnClick) {
        _this.setState({
          hide: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleTimeout", function () {
      _this.setState({
        hide: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Message, [{
    key: "render",
    value: function render() {
      return !this.state.hide ? _react.default.createElement(StyledMessage, (0, _extends2.default)({}, (0, _ObjectUtils.omit)(this.props, ['autoHide', 'closeOnClick']), {
        onClick: this.handleClickHide
      })) : null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoHide) {
        this._timeout = setTimeout(this._handleTimeout, Number.isFinite(this.props.autoHide) ? this.props.autoHide : 5000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._timeout) clearTimeout(this._timeout);
    }
  }]);
  return Message;
}(_react.PureComponent);

exports.default = Message;
(0, _defineProperty2.default)(Message, "propTypes", {
  autoHide: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.number]),
  closeOnClick: _propTypes.bool
});